import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';

const lightbox = new PhotoSwipeLightbox({
  gallery: 'ul.pswp-gallery',
  children: '.product__media-item:not(.product__media-item--full)',
  // This loads the core engine ONLY when the user clicks an image
  pswpModule: () => import('./photoswipe.esm.js'),
});

lightbox.addFilter('itemData', (itemData, index) => {
  const img = itemData.element;
  if (img) {
    itemData.src = img.dataset.pswpSrc;
    itemData.w = parseInt(img.dataset.pswpWidth, 10);
    itemData.h = parseInt(img.dataset.pswpHeight, 10);
  }
  return itemData;
});

// Initialize the gallery
lightbox.init();
